"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useShadePickerEvent = require("./useShadePickerEvent");
Object.keys(_useShadePickerEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useShadePickerEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useShadePickerEvent[key];
    }
  });
});
var _useTranslations = require("./useTranslations");
Object.keys(_useTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslations[key];
    }
  });
});
